export const API_CONSTANT = {
  STATE_DATA: "/common/states",

  ADVERDTISEMENT_DATA: "/advertise",
  REPO_DATA: "/repository",
  MEDIA_DATA: "/advertising/media",
  REPO_TYPE: "/repository/types",
  LOGIN_DATA: "",

  // Mock json

  COMPLAINT_DROPDOWN_DATA: "/assets/json/mock/complaint.json",

  QUICK_DATA: "/assets/json/mock/quick-details.json",
  COMPLAIN_DATA: "/assets/json/mock/complaint.json",

  ASSEMBLIES_LIST: "/common/assemblies",
};
